import React, { Fragment } from 'react';
import { Router } from '@reach/router';
import { createRenderedPortal } from '../utilities/reactUtilities';

import PageContextProvider from '../context/PageContext';
import PageStateContextProvider from '../context/PageStateContext';

import MainSidebar from './sidebar/MainSidebar';
import PageShowContainer from './page/PageShowContainer';
import DraftContainer from './draft/DraftContainer';
import NewDraftListener from './draft/NewDraftListener';

import { getTeamUrl } from '../utilities/urlHelper';

window.isApp = true;

const App = (props) => {
    const basepath = getTeamUrl();
    return (
        <Fragment>
            <PageContextProvider>
                <PageStateContextProvider>
                    <Router basepath={encodeURI(basepath)} className="flex-auto flex flex-column">
                        <PageShowContainer path="pages/:pageSlug" />
                        <DraftContainer path="pages/:pageSlug/edit" />
                        <DraftContainer path="drafts/:draftId/edit" />
                        <DraftContainer path="drafts/create" isNewDraft />
                    </Router>
                    <NewDraftListener />
                </PageStateContextProvider>
            </PageContextProvider>
            {createRenderedPortal(<MainSidebar />, document.getElementById('main-sidebar-container'))}
        </Fragment>
    );
};

export default App;
